/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/11/22
 */

import React, {useEffect, useState} from "react";
import {EMPLOYEE_COL_WIDTH} from "./sx";
import {differenceInMinutes} from "date-fns";
import {Stack, useTheme} from "@mui/material";

export interface NowLineProps {
	range: Interval
	rangeResolution: number
}

export default function NowLine({ range, rangeResolution }: NowLineProps) {

	const [left, setLeft] = useState(EMPLOYEE_COL_WIDTH);

	const theme = useTheme();

	useEffect(() => {
		const updatePosition = () => {
			const left = differenceInMinutes(new Date(), range.start)*rangeResolution + EMPLOYEE_COL_WIDTH;
			setLeft(left);
		}
		const int = setInterval(updatePosition, 60000);
		updatePosition();
		return () => clearInterval(int);
	}, [range.start, rangeResolution]);

	return (
		<>
			<Stack
				sx={{
					position: "absolute",
					height: "100%",
					borderLeft: "2px solid " + theme.palette.secondary.light,
					top: 0,
					zIndex: 200,
					marginTop: "3px",
					left: left
				}}
			/>
			<Stack
				sx={{
					left: left,
					position: "absolute",
					borderRadius: "50%",
					backgroundColor: theme.palette.secondary.light,
					height: "12px",
					width: "12px",
					top: 0,
					marginLeft: "-5px",
					marginTop: "3px",
					zIndex: 200
				}}
			/>
		</>
	);

}